import { render, staticRenderFns } from "./splitticket.vue?vue&type=template&id=438c7800&"
import script from "./splitticket.vue?vue&type=script&lang=js&"
export * from "./splitticket.vue?vue&type=script&lang=js&"
import style0 from "./splitticket.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports